export default {
  editor: {
    minHeight: '3vh',
  },
}
